import styled from 'styled-components';

const StyledCheckbox = styled.div({
  '.MuiFormControlLabel-root': {
    width: '290px'
  }
});
export default StyledCheckbox;
